module.exports = __webpack_public_path__ + "img/6-open-pdf.f7aef780.png";